import { EffectFade, Navigation, Pagination } from 'swiper';

import { Slider } from './slider';

class EntryBoxSlider extends Slider {
  init() {
    super.init();
  }
}

export const entryBoxSlider = () => {
  const containers = document.querySelectorAll('.js-slider-entry-box');
  containers.forEach((container) => {
    const slides = container.querySelectorAll('.swiper-slide');
    const parameters = {
      modules: [EffectFade, Navigation, Pagination],
      slidesPerView: 1,
      loop: slides.length > 1,
      loopAdditionalSlides: slides.length,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
      },
    };

    const entryBoxSliderInstance = new EntryBoxSlider(container, parameters);

    entryBoxSliderInstance.init();
  });
};
